import * as DateFns from "date-fns"

export const formatToTime = (date: Date) =>
  DateFns.format(date, "HH:mm")
